import { ifNotAuthenticated, ifAuthenticatedAndChoose, oauthConsentGuard } from '../utils';

const authRoutes = [
  {
    path: '/signin',
    name: 'auth/signin',
    component: () => import('@/portals/Authorization/Signin'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/signup',
    name: 'auth/signup',
    component: () => import('@/portals/Authorization/Signup'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/choose-portal',
    name: 'auth/choose-portal',
    component: () => import('@/portals/Authorization/ChoosePortal'),
    beforeEnter: ifAuthenticatedAndChoose
  },
  {
    path: '/forgotpassword',
    name: 'auth/forgot',
    component: () => import('@/portals/Authorization/ForgotPassword'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/resetpassword',
    name: 'auth/reset',
    component: () => import('@/portals/Authorization/ResetPassword'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/registration/:token',
    name: 'auth/registration',
    component: () => import('@/portals/Authorization/ResetPassword'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/auth-popup/:strategy',
    component: () => import('@/portals/Authorization/AuthPopup')
  },
  {
    path: '/oauth/consent',
    name: 'oauth/consent',
    component: () => import('@/views/oauth/OAuthConsent'),
    beforeEnter: oauthConsentGuard
  }
];
export { authRoutes as default };
